import { Box, Button, Card, Stack, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useGetIdentity, useRedirect, useTranslate } from 'react-admin';
import { VaultConnectionCardDialog } from './VaultConnectionCardDialog';
import { useLocation } from 'react-router';
import Label from '../../components/Label';
import {useAddVaultConnection} from './useVaultConnection';
import ContentAdd from '@mui/icons-material/Add';

const StatusMapping = {
    not_authorized:'Not Authorized',
    authorized: 'Authorized'
}

export const VaultConnectionCard = (props: any) => {
    const {connection} =  props
    return (
        <Card
            sx={{
                p: 2,
                mt:1
            }}
            className='vault-setting-card'
        >
            <Stack
                direction={'row'}
                sx={{
                    alignItems: 'center',
                }}
                className='integration-setting-stack'
            >
                <Stack
                    sx={{
                        flex: 1,
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}
                    className='integration-stack-body'
                >
                    <img
                        src={connection.logo}
                        alt={'Vault'}
                        loading="lazy"
                        height={100}
                        className='vault-setting-img'
                    />
                    <Stack
                        direction="column"
                        justifyContent="flex-start"
                        sx={{ marginLeft: 2 }}
                    >
                        <Typography variant="h5">
                            {connection.name}
                        </Typography>
                        {connection.status === "not_authorized" && <Label color="error">{StatusMapping[connection.status]}</Label>}
                        {connection.status === "authorized" && <Label color="success">{StatusMapping[connection.status]}</Label>}
                    </Stack>
                </Stack>
                <Box>
                    <ConfigureButton {...props}/>
                </Box>
            </Stack>

        </Card>
    );
};

const ConfigureButton = (props:any) => {
    const { connection,refetch } = props
    const translate = useTranslate();
    const { loaded, identity } = useGetIdentity();
    const redirect = useRedirect();
    const [open, setOpen] = useState(false)
    const { pathname, search } = useLocation();
    const {addConnection, isLoading: isLoadingAddVault} = useAddVaultConnection()
    const handleOpen = useCallback(() => {
        var redirect_url = "/setting/integrations/"+connection.service
        if (connection && connection?.id){
            redirect_url =  redirect_url + "?connection_id="+connection.id
        }
        redirect(redirect_url)
    }, [redirect, connection.service]);

    const handleClose = useCallback(() => {
        setOpen(false)
        redirect("/setting/integrations")
        refetch && refetch();
    },[redirect, setOpen]);

    useEffect(()=>{
        if(pathname.endsWith("/"+connection.service)){
            const params = new URLSearchParams(search);
            if (params.get('connection_id') === connection?.id && (params.get("success") === undefined||params.get("success") === null )){
                setOpen(true)
            }else{
                setOpen(false)
                redirect("/setting/integrations")
            }
        }
    },[pathname, redirect, connection, search, setOpen])

    const onClickAddDuplicateConnection = useCallback((data:any) => {
        console.log("onClickAuthorize", data)
        addConnection({number: 2, service_id: connection.service, redirect_uri:window.location.href, configuration: {}}, {
            onSuccess:(connection)=>{
                console.log("Connection added", connection)
            },
        })
    },[connection, addConnection])

    return (
            <div className='integration-card-right'>
            <Button
                variant="contained"
                size="large"
                className='integration-button'
                onClick={handleOpen}
            >
                {translate('resources.integrations.apideck.configure')}
            </Button>
            {/* {(connection.service === 'busybusy' && connection.status === 'authorized') && <Button
                variant="contained"
                size="large"
                sx={{
                    width: '100%',
                }}
                onClick={handleOpen}
            >
                Configure
            </Button>} */}
            {identity?.company?.allow_tsheet_duplicate_connector && connection.service == 'tsheet' && connection.number==1 && (<Button
                variant="outlined"
                size="small"
                sx={{
                    width: '20%',
                    mt:2
                }}
                onClick={onClickAddDuplicateConnection}
            >
                <ContentAdd/>
            </Button>)}
            <VaultConnectionCardDialog open={open} handleClose={handleClose} connection={connection} />
            </div>
        );
};
